import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import { MenuItem} from 'react-bootstrap'
import history from '../../history';
import PropTypes from 'prop-types'
import { routesUrls } from '../../settings/routes';
import Card from '../Card';
import CardTrashed from '../CardTrashed/CardTrashed';

class CustomItems extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {formatMessage} = this.context;
    return <React.Fragment>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.dashboard)
        }}
      >{formatMessage('navTitleDashboard')}</MenuItem>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.card)
        }}
      >{formatMessage('navTitleFlashCard')}</MenuItem>
   </React.Fragment>
  }
}

const CardTrashedPage = (props) => {
  return <Wrapper 
    renderButtonNav = {false}
    CustomItems={CustomItems}
  >
    <CardTrashed {...props} />
  </Wrapper>
}

export default CardTrashedPage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/CardTrashedPage.js